import './App.css';
import Pathfinder from './Pathfinder/Pathfinder'

function App() {

  return (
    <div className="App">
      <Pathfinder />
    </div>
  );
}

export default App;
